// src/vocabulary/A1/unit3/content.js

const content = {
  level: "A1",
  unit: 3,
  title: "Places & Directions",
  description:
    "Common places in the city and simple directions. Learn how to talk about where you go and how to get there.",

  explanation: [
    "This unit focuses on common places you see in your city or neighborhood.",
    "These words help you talk about where you go and where things are.",
    "When you talk about places, you often use verbs like 'go to' or 'is'.",
    "For example: I go to school. The hospital is near my house.",
    "Words like 'near' and 'far' help you describe distance between places.",
    "Use 'near' when something is close, and 'far' when it is not close.",
    "In English, we usually say: The place is near something.",
    "Try to describe places around you, such as your house, your school, or the market."
  ],

  items: [
    {
      word: "school",
      phonetic: "/skuːl/",
      meaning: "مدرسة",
      example: "I go to school every day."
    },
    {
      word: "hospital",
      phonetic: "/ˈhɒspɪtəl/",
      meaning: "مستشفى",
      example: "The hospital is near my house."
    },
    {
      word: "market",
      phonetic: "/ˈmɑːrkɪt/",
      meaning: "سوق",
      example: "She buys food from the market."
    },
    {
      word: "street",
      phonetic: "/striːt/",
      meaning: "شارع",
      example: "My house is on this street."
    },
    {
      word: "near",
      phonetic: "/nɪr/",
      meaning: "قريب من",
      example: "The school is near the park."
    },
    {
      word: "far",
      phonetic: "/fɑːr/",
      meaning: "بعيد عن",
      example: "The market is far from here."
    }
  ]
};

export default content;


